import React from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";

function SpotlightProd() {
  const navigate = useNavigate();
  function got(path: string) {
    navigate("/product/" + path);
    window.scrollTo(0, 0);
  }

  return (
    <section className="w-11/12 sm:w-10/12 lg:w-9/12 bg-red-700x h-max flex flex-col justify-center items-center gap-8">
      <div className="bg-primary w-full md:h-[50vh] h-max overflow-hidden relative rounded-xl grid md:grid-cols-2">
        <div className="overflow-hidden w-full relative grid place-items-center bg-teal-700x">
          <img
            src="https://i.ibb.co/nzrknWJ/photo-1596457941236-c0611cc87551-removebg-preview.png"
            alt=""
            className="md:absolute z-10 w-[300px] md:w-[400px]"
          />
        </div>
        <div className="flex flex-col relative z-20 justify-center px-4 md:px-8 py-8 items-center md:items-start">
          <p className="text-3xl lg:text-[3rem] font-bold text-white text-center md:text-left lg:w-1/2 lg:leading-[3.5rem] tracking-wide mb-4">
            ZX9 SPEAKER
          </p>
          <p className="text-sm font-medium md:font-semibold text-white/80 w-full lg:w-9/12 text-center md:text-left mb-8">
            Upgrade to premium speakers that are phenomenally built to deliver
            truly remarkable sound.
          </p>
          <Link
            to="product/ZX9-SPEAKER"
            className="w-max px-6 py-3 text-xs font-semibold relative z-40 tracking-wide bg-transparent border-2 text-white md:text-black border-white md:border-black hover:text-primary md:hover:text-primary hover:bg-white md:hover:bg-black cursor-pointer"
          >
            SEE PRODUCT
          </Link>
        </div>
        <div className="absolute bg-cir bg-cover bg-center opacity-30 grid place-items-center w-full h-full top-0"></div>
      </div>
      <div className="bg-sd bg-cover bg-bottom grid place-items-center overflow-hidden h-[40vh] w-full rounded-xl relative">
        <div className="flex flex-col gap-6 relative md:items-start justify-center items-center z-20 w-11/12">
          <p className="text-3xl lg:text-5xl uppercase tracking-wider font-extrabold">
            ZX7 Speaker
          </p>
          <button
            onClick={() => got("ZX7-SPEAKER")}
            className="w-max px-6 py-3 text-xs font-semibold tracking-wide bg-transparent border-2 text-black border-black hover:text-white hover:bg-black cursor-pointer"
          >
            SEE PRODUCT
          </button>
        </div>
        <div className="absolute top-0 left-0 bg-gradient-to-b md:bg-gradient-to-r from-transparent via-transparent to-[#f1f1f1] md:to-[#F1F1F1]/40 h-full w-full"></div>
      </div>
      <div className="h-[50vh] md:h-[40vh] w-full rounded-xl grid md:grid-cols-2 gap-4">
        <div className="bg-spek bg-cover bg-center h-full rounded-xl md:block hidden"></div>
        <div className="bg-spek bg-cover bg-center md:bg-none md:bg-[#F1F1F1] h-full flex flex-col relative overflow-hidden justify-center md:items-start items-center gap-8 p-8 md:p-4 rounded-xl">
          <p className="text-3xl lg:text-5xl uppercase tracking-wider md:text-left text-center text-white md:text-black relative z-40 font-extrabold">
            YX1 EARPHONES
          </p>
          <button
            onClick={() => got("YX1-EARPHONES")}
            className="w-max px-6 py-3 text-xs font-semibold relative z-40 tracking-wide bg-transparent border-2 text-white md:text-black border-white md:border-black hover:text-black md:hover:text-white hover:bg-white md:hover:bg-black cursor-pointer"
          >
            SEE PRODUCT
          </button>
          <div className="md:hidden block absolute h-full w-full top-0 left-0 bg-gradient-to-t from-black to-transparent"></div>
        </div>
      </div>
    </section>
  );
}

export default SpotlightProd;
